
import { FC } from 'react' ;


type Options = {

   current_Tag    : number ;
   set_Current_Tag : ( tagNo : number ) => void

}



// @ 列印聯選項
const Service_Tag_Options_M : FC< Options > = ( { current_Tag , set_Current_Tag } ) => {


    const on = { background : "rgba(120,120,150,.9)" , color : "white" }

    return <div className="columns is-variable is-1">

                <div className="column">
                <span className = { `tag is-large pointer` } style = { current_Tag === 6 ? on : {} } onClick = { () => set_Current_Tag( 6 ) } > 
                    第一、二、三聯
                </span>
                </div>

                <div className="column">
                <span className = { `tag is-large pointer` } style = { current_Tag === 7 ? on : {} } onClick = { () => set_Current_Tag( 7 ) } > 
                    第四、五聯
                </span>
                </div>

          </div>


} ;

export default Service_Tag_Options_M
       